import '../assets/css/style.min.css'
import * as Quill from 'quill'
import { g, grv_v3, grv_v4, grv_v5, log, t } from '../../../utils'
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { doc, getDoc, getFirestore, setDoc, updateDoc } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAonRA4dP7VLhJMOsyB76oMgDfJrPRuEaU",
    authDomain: "kudu-ride.firebaseapp.com",
    databaseURL: "https://kudu-ride-default-rtdb.firebaseio.com",
    projectId: "kudu-ride",
    storageBucket: "kudu-ride.appspot.com",
    messagingSenderId: "277154439302",
    appId: "1:277154439302:web:c058873c9cd89425313107",
    measurementId: "G-PVP3J4B2FN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth();

const firestore = getFirestore()

const websiteDoc = doc(firestore, "system/website")
var website = await getDoc(websiteDoc)

if (website.exists()) {
    const websiteData = website.data()
    const policies = websiteData.policies

    log(policies)

    for (const key in policies) {
        if (Object.hasOwnProperty.call(policies, key)) {
            const policy = policies[key];

            g('target_policies').appendChild(t(`<li>
            <label class="choice-tag choice-tag--radio text-sm js-choice-tag" for="radio-tag-${key}">
              <input class="sr-only" type="radio" value="${key}" name="radio-tags" id="radio-tag-${key}">
        
              <svg class="choice-tag__icon icon margin-right-xxs" viewBox="0 0 16 16" aria-hidden="true"><g class="choice-tag__icon-group"><circle cx="8" cy="8" r="7" stroke="currentColor"/><circle cx="8" cy="8" r="3"/></g></svg>
        
              <span>${key}</span>
            </label>
          </li>`))
        }
    }

    var editor = new Quill(".editor", {
        modules: {
            toolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                ['link'],
                ['blockquote', 'code-block'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                [{ 'direction': 'rtl' }],                         // text direction
                [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                [{ 'font': [] }],
                [{ 'align': [] }],
                ['clean']                                         // remove formatting button
            ]
        },
        placeholder: 'Empty document...',
        theme: 'snow'  // or 'bubble'
    })

    var targetPolicy = ""

    grv_v5("radio-tags", (v) => {
        targetPolicy = v
        g("preview").innerHTML = ""

        if (v === "about") {
            g("preview").appendChild(t(websiteData.about.content))
        } else {
            g("preview").appendChild(t(policies[v]))
        }
    })

    g('btn_update').addEventListener("click", async (el) => {
        log(editor.root.innerHTML)
        el.target.disabled = true

        if (targetPolicy === "about") {
            const data = {
                about: {
                    content: `<div class="text-component">${editor.root.innerHTML}</div>`
                }
            }

            await setDoc(websiteDoc, data, { merge: true }).then(() => {
                alert("Updated succefully!")
                location.reload()
            }).catch((e) => { alert(e.message) })
        } else {
            const data = {
                policies: {
                    [targetPolicy]: `<div class="text-component">${editor.root.innerHTML}</div>`
                }
            }

            await setDoc(websiteDoc, data, { merge: true }).then(() => {
                alert("Updated succefully!")
                location.reload()
            }).catch((e) => { alert(e.message) })
        }
    })
}


